import { render, staticRenderFns } from "./draggableTree.vue?vue&type=template&id=3f67582d&"
import script from "./draggableTree.vue?vue&type=script&lang=ts&"
export * from "./draggableTree.vue?vue&type=script&lang=ts&"
import style0 from "./draggableTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports